import React, { useCallback, useState } from 'react';
import { Icon } from '@tcc/crate';
import styles from '../scoutingForm.css';

type ScoutingFormNoteProps = {
  note: string;
  setNote: (note: string) => void;
  isEditingNote: boolean
  setIsEditingNote: React.Dispatch<React.SetStateAction<boolean>>
  children: React.ReactNode;
}

export const ScoutingFormNote = ({
  note, setNote, isEditingNote, setIsEditingNote, children
}: ScoutingFormNoteProps) => {
  const [initialNote, setInitialNote] = useState(note);

  const onClose = useCallback(() => {
    setNote(initialNote);
    setIsEditingNote(false);
  }, [initialNote, setNote, setIsEditingNote]);

  const onSave = useCallback(() => {
    setIsEditingNote(false);
    setInitialNote(note);
  }, [setInitialNote, setIsEditingNote, note]);

  return (
    <div className={styles.enhancedScoutingEditingNoteContainer} data-test-id="enhanced-scouting-note-container">
      <div data-test-id="enhanced-scouting-note">{children}</div>
      {isEditingNote ?
        <div>
          <Icon
            glyph={Icon.set.CANCEL}
            className={`${styles.enhancedScoutingIcon} ${styles.enhancedScoutingIconIsEditing} ${styles.cursorPointer}`}
            onClick={onClose}
            testId="enhanced-scouting-cancel-edit-note-icon"
          />
          <Icon
            glyph={Icon.set.MATERIAL_CHECK}
            className={`${styles.enhancedScoutingIcon} ${styles.enhancedScoutingIconIsEditing} ${styles.cursorPointer}`}
            onClick={onSave}
            testId="enhanced-scouting-confirm-edit-note-icon"
          />
        </div>
        : null
      }
    </div>
  )
}
